import React, { useState } from "react";

import { useAccount } from "../../../context/account.context";
import DesktopNavbar from "./DesktopNavbar";

export default function Navbar() {
    const [userData, setUserData] = useAccount();

    return <div className="bg-gray-200 h-full w-full z-10">
        <DesktopNavbar userData={userData} />
    </div>;
}
